export const palette = {
  palette: {
    primary: {
      main: '#fe4500',
    },
    secondary: {
      main: '#7553E8',
    },
    borderColor: '#dfdfdf',
    buzzBackground: '#f1f1f1',
    buzzContainerColor: 'white',
    buzzFade: '#707070',
    buzzFadeLite: '#f5f5f5',
    buzzBorder: '#dfdfdf',
    buzzPlaceHolder: '#dfdfdf',
    buzzBreadCrumb: '#a2a2a2',
    buzzKycFormPlaceholder: '#faf9f9',
    buzzActiveLinkBackground: '#fff6f2',
    buzzLiteGray: '#fafafa',
    buzzSuccess: '#17C558',
    buzzDisableInputColor: '#1D1D1D',
    buzzBlackTextColor: '#000',
    buzzGreyTextColor: '#666666',
    buzzLiteGreyTextColor: '#646464',
    buzzAshTextColor: '#A2A2A2',
    buzzLiteBlueBgColor: '#EEF6FF',
    buzzRedColor: '#ff0000',
    buzzReqFormBg: '#FFFBF0',
    underlineActionColor: '#441514',
    buzzFileBg: '#E8ECFF',
    buzzCheckedGreenColor: '#4FA757',
    buzzSchoolNameBg: '#B40606',
    buzzLiteGreyBg: '#FBFBFB',
    buzzGreyBarBg: '#CBCBCB',
    buzzReferroLogo: '#797979',
    buzzTotalLeadsBg: '#7553E8',
    buzzTotalConversionBg: '#441514',
    buzzTotalGiftVoucherBg: '#FE0053',
    buzzTotalPendingGiftVoucherBg: '#FFA500',
    buzzSubscriptionHeader: '#FFDACC',
    buzzAppointmentBorder: '#F2B705',
    buzzLiteGreenBg: '#EEFFF4',
  },
};
